module.exports = __webpack_public_path__ + "static/media/upp_flo_anc_clu.ce707d12.png";